// hooks/useTableFilters.ts
import { useState, useEffect } from 'react';

export function ploFiveTableFilters() {
  const [searchTerm, setSearchTerm] = useState('');
  const [courtSearch, setCourtSearch] = useState('');
  const [partySearch, setPartySearch] = useState('');
  const [selectedStatus, setSelectedStatus] = useState<string>('');
  const [ptiFirstDate, setPtiFirstDate] = useState('');
  const [ptiSecondDate, setPtiSecondDate] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const [debouncedSearch, setDebouncedSearch] = useState(searchTerm);
  const [debouncedCourt, setDebouncedCourt] = useState(courtSearch);
  const [debouncedParty, setDebouncedParty] = useState(partySearch);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
      setDebouncedCourt(courtSearch);
      setDebouncedParty(partySearch);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm, courtSearch, partySearch]);

  const handleClearFilters = () => {
    setSearchTerm('');
    setCourtSearch('');
    setPartySearch('');
    setSelectedStatus('');
    setPtiFirstDate('');
    setPtiSecondDate('');
    setCurrentPage(1);
  };

  const hasActiveFilters = Boolean(
    searchTerm ||
      courtSearch ||
      partySearch ||
      selectedStatus ||
      ptiFirstDate ||
      ptiSecondDate
  );

  return {
    searchTerm,
    setSearchTerm,
    courtSearch,
    setCourtSearch,
    partySearch,
    setPartySearch,
    selectedStatus,
    setSelectedStatus,
    ptiFirstDate,
    setPtiFirstDate,
    ptiSecondDate,
    setPtiSecondDate,
    currentPage,
    setCurrentPage,
    debouncedSearch,
    debouncedCourt,
    debouncedParty,
    handleClearFilters,
    hasActiveFilters,
  };
}